<template>
  <Modal
    v-if="dialog"
    :dialog.sync="dialog"
    title="Регистрация нового API-ключа"
    contentClass="esh-theme adminModal"
    :width="420"
  >
    <template #body>
      <v-card outlined class="infoBody">
        <v-row no-gutters>
          <v-col>
            <v-form v-model="valid">
              <v-text-field
                label="Название"
                v-model="apiKey.name"
                :rules="[rules.required]"
              />
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template #actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            :disabled="!valid"
            @click="onSave"
          >
            <v-icon left>done_all</v-icon> Создать
          </v-btn>
        </v-row>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components/common'

const initApiKeyState = {
  name: '',
}

export default {
  name: 'NewApiKeyModal',
  components: {
    Modal,
  },
  props: {
    show: {
      props: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      apiKey: { ...initApiKeyState },
      rules: {
        required: value => !!value || 'Заполните обязательно!',
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  watch: {
    show: function(state) {
      if (state) {
        this.apiKey = { ...initApiKeyState }
      }
    }
  },
  methods: {
    onSave() {
      this.$emit('apiKey:save', this.apiKey)
      this.$emit('update:dialog', false)
      this.dialog = false
    }
  }
}
</script>
